import type {
  DebugEventsQueryType,
  DebugProblemOccurrencesQueryType,
  DebugProblemsQueryType,
} from "@reflag/shared/eventAPI";

const qk = {
  onboardingStatus: (appId?: string) =>
    ["apps", appId, "onboardingStatus"] as const,
  debugEvents: (
    appId?: string,
    envId?: string,
    params?: Omit<DebugEventsQueryType, "envId" | "lastTS">,
  ) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "debugEvents",
      ...(params ? [params] : []),
    ] as const,
  debugProblems: (
    appId?: string,
    envId?: string,
    params?: Omit<DebugProblemsQueryType, "envId">,
  ) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "debugProblems",
      ...(params ? [params] : []),
    ] as const,
  debugProblemOccurrence: (
    appId: string | undefined,
    envId: string | undefined,
    params: Omit<DebugProblemOccurrencesQueryType, "envId">,
  ) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "debugProblemOccurrence",
      params,
    ] as const,
};

export { qk as appQueryKeys };
